<template>
  <section class="mb-4">
    <form method="post" @submit.prevent="onSend">
      <form-wrapper :validator="$v.form">
        <nav class="panel is-warning">
          <p class="panel-heading is-size-6">
            {{ $t('attributes.group_code') }}：{{ group_code }}
          </p>
        </nav>
        <b-field horizontal :label="$t('attributes.name')">
          <b-input v-model="group_name" disabled expanded></b-input>
        </b-field>
        <b-field horizontal :label="$t('attributes.group_cover')">
          <p class="tag is-warning">
            <a
              :href="productImageUrl(group_cover)"
              @click.prevent="onClickImage(group_cover)"
            >
              {{ group_cover }}
            </a>
          </p>
        </b-field>
        <form-group horizontal name="show" :label="$t('attributes.display')">
          <b-select v-model="form.show" name="show">
            <option value="true">{{ $t('attributes.yes') }}</option>
            <option value="false">{{ $t('attributes.no') }}</option>
          </b-select>
        </form-group>

        <form-group horizontal name="topic" :label="$t('attributes.topic')">
          <b-input
            v-model="form.topic"
            name="topic"
            maxlength="15"
            :placeholder="$t('message.please_input') + $t('attributes.topic')"
            expanded
          ></b-input>
        </form-group>

        <form-group
          horizontal
          name="description"
          :label="$t('attributes.description')"
        >
          <b-input
            v-model="form.description"
            name="description"
            maxlength="20"
            :placeholder="
              $t('message.please_input') + $t('attributes.description')
            "
            expanded
          ></b-input>
        </form-group>

        <form-group
          horizontal
          name="external_url"
          :label="$t('attributes.external_url')"
        >
          <b-input
            v-model="form.external_url"
            name="external_url"
            maxlength="100"
            :placeholder="
              $t('message.please_input') + $t('attributes.external_url')
            "
            expanded
          ></b-input>
        </form-group>
        <b-field horizontal grouped>
          <b-button
            :loading="sending"
            type="is-primary"
            native-type="submit"
            :style="{ width: '100%' }"
          >
            {{ $t('attributes.update_data') }}
          </b-button>
        </b-field>
      </form-wrapper>
    </form>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import { maxLength, required, requiredIf } from 'vuelidate/lib/validators'
import { TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'RecentlyHotTravelGroupForm',
  props: {
    travelGroup: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      sending: false,

      group_code: this.travelGroup.code,
      group_name: this.travelGroup.name,
      group_cover: this.travelGroup.picture3,
      form: this.extractFormValues(this.travelGroup),

      isImageModalActive: false,
      selectedImageUrl: null
    }
  },
  validations: {
    form: {
      show: { required },
      topic: {
        requiredIf: requiredIf(function(model) {
          return model.show === 'true'
        }),
        maxLength: maxLength(15)
      },
      description: { maxLength: maxLength(20) },
      external_url: { maxLength: maxLength(100) }
    }
  },
  watch: {
    travelGroup(newGroup) {
      this.group_code = newGroup.code
      this.group_name = newGroup.name
      this.group_cover = newGroup.picture3
      this.form = this.extractFormValues(newGroup)
    },
    'form.show'() {
      this.$v.$reset()
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        show: data.is_home,
        topic: data.home_description,
        description: data.remark3,
        external_url: data.external_url
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = this.productImageUrl(url)
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const api = `${TRAVEL_GROUPS_API}/${this.group_code}/home-recommend`
      try {
        this.sending = true
        const res = await this.axios.put(api, this.form)

        this.$emit('updated', res.data.data)
        notifyService.success(`${this.$t('attributes.update_succeed')}`)
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
